module.exports = __webpack_public_path__ + "buycrypto_transfer_button.svg?3d1ce608a7937eb62037d1bc33a51b98";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/buycrypto_transfer_button.svg
// module id = 838
// module chunks = 2